import MetricsDataPage from '@/pages/monitoring/MetricsDataPage.vue'
import VopMessagePage from '@/pages/monitoring/VopMessagePage.vue'

export default [
  {
    path: '/monitoring/metricsData/:id',
    component: MetricsDataPage,
    props: true
  },
  {
    path: '/monitoring/vopMessage/:id',
    component: VopMessagePage,
    props: true
  }
]
